<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :hide-default-header="true"
    :custom-filter="customFilter"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
          >
            <span>{{ header.text }}</span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>

        <!-- <v-btn
          v-if="myLevel<10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn> -->
        <v-btn
          v-if="myLevel<10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="isShowDialog = true;editingId=-1"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <leave-form-list-item
        :item="item"
        :key="`item-${item.ID}`"
        @edit="showEditDialog"
        @remove="deleteItem"
      />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>

        <leave-form-addedit-dialog
          v-model="isShowDialog"
          :editing-id="editingId"
          @updated="onDataUpdated"
        />

        <v-snackbar
          v-model="isDataRefetched"
          :timeout="-1"
        >
          偵測到資料已更新
          <v-btn
            class="ml-1 mr-1"
            color="pink"
            text
            @click="isDataRefetched = false"
          >
            關閉
          </v-btn>
          <v-btn
            class="ml-1 mr-1"
            color="white"
            text
            @click="reloadDataTable"
          >
            重新載入
          </v-btn>
        </v-snackbar>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import LeaveFormAddeditDialog from "@/ui/leave-form/leave-form-addedit-dialog.vue";
import LeaveFormListItem from "./leave-form-list-item.vue";
import XMLGenerator from "@/data/excel/xml-generator-leave-form.js";
import XLSXSaver from "@/data/excel/xlsx-saver.js";

import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";
export default {
  mixins: [mixinDelaySearch],
  components: {
    LeaveFormAddeditDialog,
    LeaveFormListItem
  },
  data: () => ({
    isLoading: false,
    // data table
    dataTable: [],
    pageTitle: "請假系統",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    search: "",
    // addedit
    isShowDialog: false,
    editingId: -1,
    // data refetched
    isDataRefetched: false
  }),
  computed: {
    headers() {
      let actionHeader = {
        text: "操作",
        value: "action",
        showInMobile: true
      };
      return [
        {
          text: "申請人",
          value: "-",
          showInMobile: true
        },
        {
          text: "假別",
          value: "-",
          showInMobile: true
        },
        {
          text: "時間",
          value: "-",
          showInMobile: true
        },
        { text: "代理人", value: "Name", showInMobile: false },
        { text: "狀態", value: "Name", showInMobile: false }
      ].concat([actionHeader]);
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    ...mapGetters(["myLevel", "countries", "users"])
  },
  methods: {
    exportExcel() {
      let datas = this.dataTable.filter(
        o => !this.search || o.Name.includes(this.search)
      );
      let result = XMLGenerator.generate(this, datas);
      

      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-假單-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }
      XLSXSaver.saveAs(result, fileName);
    },
    customFilter(value, search, o) {
      let agent = this.users.find(u => u.ID == o.AgentID) || {Profile:{}}
      let user = this.users.find(u => u.ID == o.CreatedBy) || {Profile:{}}
      return !search ||
          agent.Profile.Name.includes(search) ||
          user.Profile.Name.includes(search) ||
          user.Username.includes(search)
    },
    showEditDialog(itemID) {
      this.editingId = itemID;
      this.isShowDialog = true;
    },
    deleteItem(item) {
      const removingIdx = this.$store.state.leaveForm.list.indexOf(item);

      this.isLoading = true;
      this.$services.leaveForm
        .inActivate(this, item.ID)
        .then(res => {
          this.$store.state.leaveForm.list.splice(removingIdx, 1);
          // this.$alertMessage("成功刪除假單「" + item.Name + "」!");
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reloadDataTable() {
      this.dataTable = this.$store.state.leaveForm.list.filter(o => o.IsActive);
      this.isDataRefetched = false;
      this.$store.state.leaveForm.isReloaded = false;
    },
    onDataUpdated(item) {
      // let action = this.editingId >= 0 ? "編輯" : "新增";
      // this.$alertMessage("成功" + action + "假單「" + item.Reason + "」!");
      this.reloadDataTable();
    }
  },
  created() {
    this.isLoading = true;
    this.$services.prepareDatas(this).then(() => {
      this.$services.department
        .prepareData(this)
        .then(this.reloadDataTable)
        .finally(() => {
          this.isLoading = false;
        });
    });
  },
  watch: {
    "$store.state.leaveForm.isReloaded"() {
      if (
        this.$store.state.leaveForm.isFetched &&
        this.$store.state.leaveForm.isReloaded
      )
        this.isDataRefetched = true;
    }
  }
};
</script>